<template>
  <div class="page container">

    <div class="row mt-2">

      <div class="col-12 text-left">

      
        <h3> Pedidos  </h3>

        <hr />
  
        <div>
                
        <h5> Ver pedidos das listas de:  </h5>
        <div v-for="lista in pedidosPorListaInfo" 
                :key="'pedido'+lista.id" 
                class="list-group-item list-group-item-action ">

         

            <router-link :to="'pedidos/'+lista.id" tag="div" class="row pointer">
              <div class="col-12 col-sm-8 my-3">
                    <b>{{lista.id}}</b> - <small> <b>{{lista.pedidos.length}} pedidos</b></small>
                </div>
            </router-link >
            </div>
        


        </div>

      </div>


    </div>
      <!-- <pre>{{pedidosPorListaInfo}}</pre> -->

  </div>

</template>

<script>


import has from 'lodash/has'

import { SquareIcon, CheckSquareIcon, Trash2Icon, PrinterIcon } from 'vue-feather-icons'
export default {
      
    // components: {SquareIcon, CheckSquareIcon, Trash2Icon, PrinterIcon},
  computed:{
    pedidos:function(){
          return this.$store.getters.pedidos
      },
      pedidosPorListaInfo:function(){
       return this.$store.getters.listaPedidos
      },
  },

  created:function(){
    this.$store.dispatch('getPedidos')
  },

  methods:{

  }

}
</script>
